export const getEventPath = (event: Event) => {
  const path = event.composedPath() as HTMLElement[];

  // remove html, document, window
  const indexOfHtml = path.findIndex(el => el.tagName === 'HTML');
  return path.slice(0, indexOfHtml);
};

const getPathInternal = (el: Node, path = []) => {
  if (!el.parentNode) return path;
  return getPathInternal(el.parentNode, [...path, el.parentNode]);
};

export const getNodePath = (sourceEl: Node): Node[] => {
  return getPathInternal(sourceEl, [sourceEl]);
};
